/*
 * Search Reducer
 */
import {
  OPSLAG,
  OPSLAG_SUCCESS,
  OPSLAG_ERROR,
  DAWA_LOOKUP,
  DAWA_LOOKUP_SUCCES,
  DAWA_LOOKUP_ERROR,
} from './../actions/Search';
import { CLEAR_ACTION_RESPONSE } from './../actions/Global';
import { Record, List, fromJS } from 'immutable';
import { convertAxiosSuccess, convertAxiosError } from './../utility/ConverterUtils';

/* The initial state of the App */
const SearchStateRecord = Record({
  unpaidFees: List(),
  addressSuggestions: List(),
  isLoading: false,
  actionResponse: null,
  dawaError: null,
});

const search = (state = new SearchStateRecord({}), action) => {
  switch (action.type) {
    case OPSLAG:
      return opslag(state);
    case OPSLAG_SUCCESS:
      return opslagSuccess(state, action);
    case OPSLAG_ERROR:
      return opslagError(state, action);

    case DAWA_LOOKUP:
      return dawaLookup(state);
    case DAWA_LOOKUP_SUCCES:
      return dawaLookupSuccess(state, action);
    case DAWA_LOOKUP_ERROR:
      return dawaLookupError(state, action);

    case CLEAR_ACTION_RESPONSE:
      return clearActionResponse(state);

    default:
      return state;
  }
};

const opslag = (state) => {
  return state.setIn(['unpaidFees'], state.unpaidFees.clear()).setIn(['isLoading'], true);
};

const opslagSuccess = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['unpaidFees'], fromJS(action.payload.result.unpaidFees))
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const opslagError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const dawaLookup = (state) => {
  return state
    .setIn(['addressSuggestions'], state.addressSuggestions.clear())
    .setIn(['dawaError'], null);
};

const dawaLookupSuccess = (state, action) => {
  return state.setIn(['addressSuggestions'], fromJS(action.payload));
};

const dawaLookupError = (state, action) => {
  return state.setIn(['dawaError'], fromJS(action.payload));
};

/** Clears the reducer errors */
const clearActionResponse = (state) => {
  return state.setIn(['actionResponse'], null);
};

export default search;
